export default "Message from Coast Guard Maritime Radio.\nOne of the missing persons is the chief engineer.\nThe coaster is carrying fertilizer.";